import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type QuickOrderPayload, initialState } from "../../types/quickOrder";
import { type RootState } from "../root/config.store";
import { UpdateOrderPayload } from "./saga";

// Post Slice
export const quickOrderSlice = createSlice({
  name: "quickOrder",
  initialState,
  reducers: {
    submitQuickOrder(state, action: PayloadAction<QuickOrderPayload>) {
      state.data = action.payload;
      state.success = false;
      state.loading = true;
      state.error = null;
    },
    submitQuickOrderSuccess(state, action: PayloadAction<QuickOrderPayload>) {
      state.data = action.payload;
      state.error = null;
      state.loading = false;
      state.success = true;
    },
    submitQuickOrderFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    saveFormData(state, action: PayloadAction<QuickOrderPayload>) {
      state.data = action.payload;
    },
    fetchQuickOrderDataStart(state, action: PayloadAction<number>) {
      state.loading = true;
      state.error = null;
    },
    fetchQuickOrderDataSuccess(
      state,
      action: PayloadAction<QuickOrderPayload>
    ) {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchQuickOrderDataFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    resetQuickOrderState(state) {
      state.success = false;
      state.error = null;
      state.loading = false;
    },
    updateQuickOrder(state, action: PayloadAction<UpdateOrderPayload>) {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    updateQuickOrderSuccess(state, action: PayloadAction<QuickOrderPayload>) {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
      state.success = true;
    },
    updateQuickOrderFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Actions
export const quickOrderActions = {
  submitQuickOrderStart: quickOrderSlice.actions.submitQuickOrder,
  submitQuickOrderSuccess: quickOrderSlice.actions.submitQuickOrderSuccess,
  submitQuickOrderFailure: quickOrderSlice.actions.submitQuickOrderFailure,
  saveFormData: quickOrderSlice.actions.saveFormData,
  fetchQuickOrderDataStart: quickOrderSlice.actions.fetchQuickOrderDataStart,
  fetchQuickOrderDataSuccess:
    quickOrderSlice.actions.fetchQuickOrderDataSuccess,
  fetchQuickOrderDataFailure:
    quickOrderSlice.actions.fetchQuickOrderDataFailure,
  updateQuickOrderStart: quickOrderSlice.actions.updateQuickOrder,
  updateQuickOrderSuccess: quickOrderSlice.actions.updateQuickOrderSuccess,
  updateQuickOrderFailure: quickOrderSlice.actions.updateQuickOrderFailure,
  resetQuickOrderState: quickOrderSlice.actions.resetQuickOrderState,
};

// Selectors
export const selectQuickOrder = (state: RootState): QuickOrderPayload =>
  state.quickOrder.data;

// Reducer
export default quickOrderSlice.reducer;
